module.exports = __webpack_public_path__ + "static/vitalBg-a51a0ce2e4a09c7c84c061d9a8aa5287.jpg";